import { HeadCell, HierarchyHeadCell } from './commonComponents';

export interface TableHeaderColumn {
  key: string;
  header: React.ReactNode;
}

interface TableHeaderProps {
  visibleColumns: TableHeaderColumn[];
  title:  string;
  children?: React.ReactNode;
}

const TableHeader = ({ visibleColumns = [], title, children }: TableHeaderProps) => {
  return (
    <thead>
      <tr>
        {!!title && <HierarchyHeadCell> {children} {title}</HierarchyHeadCell>}
        {visibleColumns.map((column) => (
          <HeadCell key={column.key}>{column.header}</HeadCell>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;